<div class="text-surface-900 dark:text-surface-0 p-4  font-medium text-3xl mb-8">
  Pazaryeri Özel
</div>

@if (product && providerProduct && providerSettings) {
    <div class="bg-surface-50 dark:bg-surface-800 p-2 md:px-4 lg:px-6">

        <div class="bg-surface-0 dark:bg-surface-800 p-6 shadow rounded-border">
            <div class="grid grid-cols-12 gap-4  ">
                <div class="mb-4 col-span-12 md:col-span-6">
                    <label
                            for="shippingTemplate" 
                            class="m-form-label">Kargo Şablonu</label>
                    <p-select
                      class="w-full"
                            id="shippingTemplate" [(ngModel)]="providerProduct.ShippingTemplateId"
                            (ngModelChange)="validation()" [options]="shippingTemplate" optionLabel="Name"
                            [filter]="true" filterBy="Name" optionValue="Id" [showClear]="false"
                            placeholder="Kargo Şablonu Seçimi Yapınız"></p-select>
                </div>
                <div class="mb-4 col-span-12 md:col-span-6">
                    <label
                            for="ProviderSku" class="m-form-label">Pazaryeri Stok Kodu</label>
                    <input
                      class="w-full"
                            id="ProviderSku" [(ngModel)]="providerProduct.ProviderSku" (ngModelChange)="validation()"
                            type="text" pInputText/>
                </div>
              @if(product.IsVariant && (!providerSettings.Variant.supporting || providerProduct.VariantCode !== '') && (providerProduct.Id !== '')){
                <div  class="md:col-span-6">
                  <label class="m-form-label mb-2 block">Varyant kodu</label>
                   <p-select
                     [disabled]="true"
                     class="w-full"
                     [options]="product.VariantItems" appendTo="body"
                     id="variant"
                     [(ngModel)]="providerProduct.VariantCode"
                     placeholder="Lütfen Varyant  Kodu Seçiniz"
                     optionLabel="Code"
                     optionValue="Code"
                ></p-select>
                </div>
              }


                <div class="border-surface border-t opacity-50 mb-4 col-span-12"></div>
                <div class="col-span-12">

                    @if (formSettings && detailsForm) {
                        <form [formGroup]="detailsForm">
                            <div class="grid grid-cols-12 gap-4  ">
                                @for (formSetting of formSettings; track formSetting; let i = $index) {

                                  @if (formSetting.inputType === InputType.text || formSetting.inputType === InputType.modelCode) {
                                    <div class="mb-4 col-span-12 md:col-span-6">
                                      <label [for]="formSetting.field" class="m-form-label">{{ formSetting.header }}</label>
                                      <input
                                        class="w-full"
                                        [placeholder]="formSetting.header"
                                        pInputText [id]="formSetting.field"
                                        formControlName="{{formSetting.field}}"
                                      />
                                      <small class="text-red-500">
                                        @if (showError || detailsForm.controls[formSetting.field].invalid &&
                                        (detailsForm.controls[formSetting.field].dirty || detailsForm.controls[formSetting.field].touched)) {
                                          @if (detailsForm.controls[formSetting.field].errors?.['required']) {
                                            Lütfen {{formSetting.header}} alanını doldurunuz.
                                          }
                                        }
                                      </small>
                                    </div>
                                  }

                                  @else if (formSetting.inputType === InputType.number) {
                                    <div class="mb-4 col-span-12 md:col-span-6">
                                      <label [for]="formSetting.field" class="m-form-label">{{ formSetting.header }}</label>
                                      <p-inputNumber
                                        [allowEmpty]="false"
                                        class="w-full"
                                        [placeholder]="formSetting.header"
                                        [id]="formSetting.field" formControlName="{{formSetting.field}}"
                                        [inputId]="formSetting.field"
                                      />
                                      <small class="text-red-500">
                                        @if (showError ||detailsForm.controls[formSetting.field].invalid &&
                                        (detailsForm.controls[formSetting.field].dirty || detailsForm.controls[formSetting.field].touched)) {
                                          @if (detailsForm.controls[formSetting.field].errors?.['required']) {
                                            Lütfen {{formSetting.header}} alanını doldurunuz.
                                          }
                                        }
                                      </small>
                                    </div>
                                  }

                                  @else if (formSetting.inputType === InputType.dropdown) {
                                    <div class="mb-4 col-span-12 md:col-span-6">
                                      <label [for]="formSetting.field" class="m-form-label">{{ formSetting.header }}</label>
                                      <p-select
                                        class="w-full"
                                        [id]="formSetting.field" formControlName="{{formSetting.field}}"
                                        [inputId]="formSetting.field" [options]="formSetting.fields"
                                        optionLabel="header" optionValue="field" [showClear]="true"
                                        [filter]="true" appendTo="body"
                                        [placeholder]="formSetting.header">
                                      </p-select>
                                      <small class="text-red-500">
                                        @if (showError ||detailsForm.controls[formSetting.field].invalid &&
                                        (detailsForm.controls[formSetting.field].dirty || detailsForm.controls[formSetting.field].touched)) {
                                          @if (detailsForm.controls[formSetting.field].errors?.['required']) {
                                            Lütfen {{formSetting.header}} için değer seçiniz.
                                          }
                                        }
                                      </small>
                                    </div>
                                  }

                                  @else if (formSetting.inputType === InputType.switch) {
                                    <div class="mb-4 col-span-12 md:col-span-6">
                                      <label [for]="formSetting.field" class="m-form-label">{{ formSetting.header }}</label>
                                      <div id="OrderStatusTracking" class="flex items-center gap-4">
                                        @if (formSetting.field === "KnowHbSku") {
                                          <p-toggleswitch [trueValue]="'true'" [falseValue]="'false'"
                                                         formControlName="{{formSetting.field}}"
                                                         [inputId]="formSetting.field">
                                          </p-toggleswitch>
                                        } @else {
                                          <p-toggleswitch
                                            formControlName="{{formSetting.field}}"
                                            [inputId]="formSetting.field">
                                          </p-toggleswitch>
                                        }
                                      </div>
                                    </div>
                                  }

                                  @else if (formSetting.inputType === InputType.date) {
                                    <div class="mb-4 col-span-12 md:col-span-6">
                                      <label [for]="formSetting.field" class="m-form-label">{{ formSetting.header }}</label>
                                      <p-datePicker
                                        styleClass="w-full"
                                        class="w-full"
                                        [readonlyInput]="true"
                                        (onSelect)="formatDate()"
                                        [autofocus]="false"
                                        [showIcon]="true"
                                        [showOnFocus]="false"
                                        appendTo="body"
                                        dateFormat="dd.mm.yy"
                                        [id]="formSetting.field" formControlName="{{formSetting.field}}"
                                        [placeholder]="formSetting.header"/>

                                    </div>
                                  }





                                }
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div>
    </div>


    <div class="flex   bg-surface-0 dark:bg-surface-800  h-20 gap-2 border-t border-surface pt-4">

        <div class="ml-auto">

            <p-button [loading]="loading"
                     icon="pi pi-check" (click)="addUpdate()"
                    [label]="providerProduct.Id.length > 0 ? 'Güncelle': 'Kaydet'"></p-button>


        </div>
    </div>

}

